module.exports = __webpack_public_path__ + "img/lock_premium.96932809.png";